module.exports = __webpack_public_path__ + "static/media/8.a118ebd0.JPG";